"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgStatusSnoozed = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 48, height: 48, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("circle", { cx: 24, cy: 24, r: 24, fill: "#6F6E89" }), (0, jsx_runtime_1.jsx)("path", { d: "M27.446 17.897h-2.949l-.12.008a.885.885 0 0 0 .12 1.761h1.23l-1.95 2.73-.065.105a.885.885 0 0 0 .785 1.293h2.949l.12-.008a.885.885 0 0 0-.12-1.761h-1.23l1.95-2.73.065-.105a.885.885 0 0 0-.785-1.293ZM34.522 12h-4.128l-.12.008a.885.885 0 0 0 .12 1.761h2.517l-3.263 5.127-.058.106a.885.885 0 0 0 .804 1.254h4.128l.12-.008a.885.885 0 0 0-.12-1.761h-2.517l3.263-5.128.058-.105A.885.885 0 0 0 34.522 12Z", fill: "#fff" }), (0, jsx_runtime_1.jsx)("path", { d: "M24.437 16.128h3.008c.599 0 1.128.187 1.552.494l.742-1.165a2.655 2.655 0 0 1-1.996-2.43 8.846 8.846 0 0 0-12.971 7.513l-.005.295v4.731l-1.669 3.728a1.12 1.12 0 0 0 1.023 1.578h18.987a1.12 1.12 0 0 0 1.022-1.58l-1.672-3.726v-3.541h-2.065c-.158 0-.311-.013-.46-.038a2.654 2.654 0 0 1-2.131 3.552l-.059.008-.239.016h-3.008c-2.04 0-3.26-2.164-2.349-3.889l.028-.053.128-.206.451-.632a2.654 2.654 0 0 1 1.384-4.631l.06-.008.239-.016ZM27.101 32.053a3.54 3.54 0 0 1-6.978 0h6.978Z", fill: "#fff" })] }))); };
exports.default = SvgStatusSnoozed;
